import {IPageData} from 'Common/PageConfig';

export function Title(data:IPageData)
{
	const pageName = data.pageDisplayName ? data.pageDisplayName + ' @ ' : '';
	const venueName = data.venue.nickname ?? data.venue.name;

	return `${pageName}${venueName}`;
}
